// Script de migración para transferir datos de Realtime Database a Firestore
import { database } from '../services/firebase';
import { ref, get } from 'firebase/database';
import { db } from '../firebase/config';
import { collection, doc, writeBatch } from 'firebase/firestore';

export const migratePedidosToFirestore = async () => {
  try {
    console.log('Iniciando migración de pedidos a Firestore...');
    
    // Obtener datos de Realtime Database
    const pedidosRef = ref(database, 'pedidos');
    const snapshot = await get(pedidosRef);
    
    if (!snapshot.exists()) {
      console.log('No hay pedidos en Realtime Database para migrar');
      return;
    }
    
    const pedidos = snapshot.val();
    const pedidosArray = Object.keys(pedidos).map(key => ({
      id: key,
      ...pedidos[key]
    }));
    
    console.log(`Encontrados ${pedidosArray.length} pedidos para migrar`);
    
    // Migrar a Firestore en lotes
    const batch = writeBatch(db);
    const pedidosCollection = collection(db, 'pedidos');
    
    let batchCount = 0;
    const BATCH_SIZE = 500; // Firestore permite máximo 500 operaciones por lote
    
    for (const pedido of pedidosArray) {
      const { id, ...pedidoData } = pedido;
      
      // Convertir fechas de string a Date si es necesario
      if (pedidoData.fechaCreacion && typeof pedidoData.fechaCreacion === 'string') {
        pedidoData.fechaCreacion = new Date(pedidoData.fechaCreacion);
      }
      if (pedidoData.fechaActualizacion && typeof pedidoData.fechaActualizacion === 'string') {
        pedidoData.fechaActualizacion = new Date(pedidoData.fechaActualizacion);
      }
      
      const docRef = doc(pedidosCollection, id);
      batch.set(docRef, pedidoData);
      batchCount++;
      
      // Ejecutar lote cuando alcance el tamaño máximo
      if (batchCount >= BATCH_SIZE) {
        await batch.commit();
        console.log(`Migrados ${batchCount} pedidos...`);
        batchCount = 0;
      }
    }
    
    // Ejecutar lote final si hay datos restantes
    if (batchCount > 0) {
      await batch.commit();
      console.log(`Migrados ${batchCount} pedidos finales...`);
    }
    
    console.log('Migración de pedidos completada exitosamente');
    return { success: true, count: pedidosArray.length };
    
  } catch (error) {
    console.error('Error durante la migración:', error);
    return { success: false, error: error.message };
  }
};

// Función para verificar si ya existen datos en Firestore
export const checkFirestoreData = async () => {
  try {
    const { getDocs, collection } = await import('firebase/firestore');
    const pedidosSnapshot = await getDocs(collection(db, 'pedidos'));
    const choferesSnapshot = await getDocs(collection(db, 'choferes'));
    
    return {
      pedidos: pedidosSnapshot.docs.length,
      choferes: choferesSnapshot.docs.length
    };
  } catch (error) {
    console.error('Error al verificar datos de Firestore:', error);
    return { pedidos: 0, choferes: 0 };
  }
};
